module.exports = "/_next/static/resources/sourcing-7f44725c32c01600b988b06d1932f604.jpg";